import { useState } from "react";
import { Menu, X } from "lucide-react";
import nullGuardLogo from "@/assets/null-guard-logo.svg";
import incibeLogo from "@/assets/incibe-emprende.png";

const navLinks = [
  { href: "#simulacion", label: "Simulación" },
  { href: "#test", label: "Test de riesgo" },
  { href: "#solucion", label: "Solución" },
  { href: "#contacto", label: "Contacto" },
];

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-border/50 bg-background/80 backdrop-blur-xl">
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        <a href="/" className="flex items-center gap-2">
          <img src={nullGuardLogo} alt="Null Guard — Inicio" className="h-10 w-auto" width={40} height={40} />
        </a>
        <nav className="hidden items-center gap-6 md:flex" aria-label="Navegación principal">
          {navLinks.map((link) => (
            <a key={link.href} href={link.href} className="text-sm text-muted-foreground transition-colors hover:text-foreground">
              {link.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a href="https://www.incibe.es/incibe-emprende" target="_blank" rel="noopener noreferrer">
            <img src={incibeLogo} alt="Sello INCIBE Emprende — visitar INCIBE" className="h-12 w-auto" width={48} height={48} />
          </a>
          <button
            className="inline-flex items-center justify-center rounded-md p-2 text-muted-foreground transition-colors hover:text-foreground md:hidden"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label={mobileOpen ? "Cerrar menú" : "Abrir menú"}
            aria-expanded={mobileOpen}
          >
            {mobileOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <nav className="border-t border-border/50 bg-background/95 backdrop-blur-xl md:hidden" aria-label="Navegación móvil">
          <div className="container mx-auto flex flex-col gap-1 px-4 py-3">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
              >
                {link.label}
              </a>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
};

export default Header;
